var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFormat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.41667 29C1.77222 29 1.20833 28.7583 0.725 28.275C0.241667 27.7917 0 27.2278 0 26.5833V2.41667C0 1.77222 0.241667 1.20833 0.725 0.725C1.20833 0.241667 1.77222 0 2.41667 0H26.5833C27.2278 0 27.7917 0.241667 28.275 0.725C28.7583 1.20833 29 1.77222 29 2.41667V26.5833C29 27.2278 28.7583 27.7917 28.275 28.275C27.7917 28.7583 27.2278 29 26.5833 29H2.41667ZM2.41667 26.5833H26.5833V2.41667H2.41667V26.5833ZM6.60556 22.6764H9.02222V14.4194H6.60556V22.6764ZM19.9778 22.6764H22.3944V5.75972H19.9778V22.6764ZM13.2917 22.6764H15.7083V17.9236H13.2917V22.6764ZM13.2917 14.4194H15.7083V12.0028H13.2917V14.4194ZM2.41667 26.5833V2.41667V26.5833Z",
    fill: "#3B82F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormat);
export default __webpack_public_path__ + "static/media/format.99bbe6bd5b4bf38877ffab3df52b093b.svg";
export { ForwardRef as ReactComponent };